import { CopyToClipboard } from "./clipboard";

/**
 * support-actions.js
 * - Optimizes scroll locking to prevent "top-to-bottom" jumping.
 * - Handles scrollbar width to prevent horizontal layout shifting.
 * - Efficiently manages "seen" VINs in localStorage.
 */
(() => {
    const root = document.getElementById("support-actions");
    if (!root) return;

    const vin = root.dataset.vin;
    const STORAGE_KEY = "support_actions_seen_v2";
    const MAX_ITEMS = 200;
    const TTL_MS = 1000 * 60 * 60 * 24 * 180; // 180 days
    const VISIBILITY_THRESHOLD = 0.95;

    // DOM Elements
    let backdrop = root.querySelector(".support-actions__backdrop");
    if (backdrop && backdrop.parentElement !== document.body) {
        document.body.appendChild(backdrop);
    }

    // --- Utilities ---

    const Storage = {
        load() {
            try {
                const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
                return Array.isArray(data) ? data : [];
            } catch { return []; }
        },
        save(data) {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            } catch (e) { /* Storage full or private mode */ }
        },
        prune(data) {
            const now = Date.now();
            return data
                .filter(item => (now - item.t) < TTL_MS)
                .slice(-MAX_ITEMS); // Keep only the most recent items
        }
    };

    // --- Action Logic ---

    const closeOverlay = () => {
        root.classList.remove("support-actions--overlay");
        document.body.classList.remove("support-actions-overlay-open");
    };

    const openOverlay = () => {
        root.classList.add("support-actions--overlay");
        document.body.classList.add("support-actions-overlay-open");
        
        // Smoothly bring the CTA into view
        root.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    // --- Events ---

    root.addEventListener("click", (e) => {
        const target = e.target;

        // Close button
        if (target.closest(".support-actions__close")) {
            closeOverlay();
            return;
        }

        // Copy Action
        const copyEl = target.closest('[data-action="copy-url"]');
        if (copyEl) {
            e.preventDefault();
            e.stopPropagation();

            const text = copyEl.dataset.copyText || window.location.href;
            CopyToClipboard(text);
            closeOverlay();
            return;
        }

        // Navigation links
        if (target.closest("a.support-actions__item")) {
            closeOverlay();
        }
    });

    // History back/forward
    window.addEventListener("popstate", () => {
        closeOverlay();
    });

    // --- Trigger Logic ---

    if (vin) {
        let store = Storage.prune(Storage.load());
        const alreadySeen = store.some(item => item.v === vin);

        if (!alreadySeen && store.length < MAX_ITEMS) {
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.intersectionRatio >= VISIBILITY_THRESHOLD) {
                    openOverlay();
                    
                    // Save to history
                    store.push({ v: vin, t: Date.now() });
                    Storage.save(store);
                    
                    observer.disconnect();
                }
            }, { 
                threshold: [VISIBILITY_THRESHOLD] 
            });

            observer.observe(root);
        }
    }
})();
